
import SignIn from './SignIn.vue'
import Register from './Register.vue'

import { Ref, ref, computed } from 'vue'

export default {
  components: {
    SignIn,
    Register
  },
  setup() {
    type SignInOrRegister = 'sign-in' | 'register'
    const signInOrRegister: Ref<SignInOrRegister> = ref('sign-in')

    function signInMode() {
      signInOrRegister.value = 'sign-in'
    }
    function registerMode() {
      signInOrRegister.value = 'register'
    }

    const tabClasses = computed(() => {
      return {
        signIn: 'tab ' + (signInOrRegister.value == 'sign-in' ? 'active' : ''),
        register:
          'tab ' + (signInOrRegister.value == 'register' ? 'active' : '')
      }
    })

    return { signInOrRegister, signInMode, registerMode, tabClasses }
  }
}
